@if (searchInitialized) {
  <div class="container" [class.inline-container]="type() === 'inline'">
    <!-- Modal Header (when not inline) -->
    @if (type() !== 'inline') {
      <ion-header>
        <ion-toolbar [color]="headerColor">
          @if (advanceType() === 'advance') {
            <ion-title>Incluir Adiantamento (débito)</ion-title>
          }
          @if (advanceType() === 'credit') {
            <ion-title>Incluir crédito</ion-title>
          }
          @if (!advanceType()) {
            <ion-title>Selecionar beneficiário</ion-title>
          }
          <ion-buttons slot="end">
            <ion-button (click)="select()">Fechar</ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
    }
    <!-- Search and Filter Section -->
    <div class="search-section" [class.inline-mode]="type() === 'inline'">
      <div class="search-container">
        <div class="search-field">
          <div #isSearchboxPayeesList class="searchbox custom-searchbox"></div>
        </div>
        @if (!isLinkedPayeeSelection()) {
          <div class="status-filter">
            <span class="status-filter-label">Status</span>
            <ion-select
              interface="popover"
              [value]="statusFilter"
              (ionChange)="onStatusFilterChange($event.detail.value)"
              placeholder="Todos"
              >
              <ion-select-option value="">Todos</ion-select-option>
              <ion-select-option value="ACTIVE">Ativo</ion-select-option>
              <ion-select-option value="INVITED">Convidado</ion-select-option>
              <ion-select-option value="NOT_INVITED">Não convidado</ion-select-option>
              <ion-select-option value="BLOCKED">Bloqueado</ion-select-option>
            </ion-select>
          </div>
        }
        <div class="pagination-container">
          <div #isPaginationPayeesList class="pagination custom-pagination"></div>
        </div>
      </div>
      <div class="stats-container">
        <div #isStatsPayeesList class="stats"></div>
      </div>
      @if (type() === 'inline') {
        <div class="status-messages">
          @if (isLinkedPayeeSelection() && hits?.length > 0) {
            <div class="info-card">
              <ion-icon name="information-circle-outline" class="info-icon" />
              <div class="info-text">
                <h4>Filtragem Ativa</h4>
                <p>Listando apenas beneficiários que não foram convidados para a BPA, e que não possuem beneficiários vinculados</p>
              </div>
            </div>
          }
          @if (hits?.length === 0) {
            <div class="empty-state">
              <ion-icon name="search-outline" class="empty-icon" />
              <h3>Nenhum resultado encontrado</h3>
              <p>Tente ajustar os termos de busca ou verifique os filtros aplicados</p>
            </div>
          }
        </div>
      }
    </div>

    <!-- Results Section - Modal Usage -->
    @if (type() !== 'inline') {
      <ion-content [fullscreen]="false" class="results-content">
        <div class="status-messages">
          @if (hits?.length === 0) {
            <div class="empty-state">
              <ion-icon name="search-outline" class="empty-icon" />
              <h3>Nenhum resultado encontrado</h3>
              <p>Tente ajustar os termos de busca ou verifique os filtros aplicados</p>
            </div>
          }
        </div>
        @if (hits?.length > 0) {
          <div class="table-container">
            <ng-container *ngTemplateOutlet="payeesTable; context: { $implicit: hits }" />
          </div>
        }
      </ion-content>
    }

    <!-- Results Section - Inline Usage -->
    @if (type() === 'inline') {
      <div class="content-section" #inlineResults>
        @if (hits?.length > 0) {
          <div class="payees-container">
            <div class="table-container">
              <ng-container *ngTemplateOutlet="payeesTable; context: { $implicit: hits }" />
            </div>
          </div>
        }
      </div>
    }
  </div>
} @else {
  <div class="ion-text-center ion-margin-top big-margin">
    <ion-spinner color="primary" name="lines" class="big-spinner" />
  </div>
}

<!-- Shared datatable template used by both inline and modal modes -->
<ng-template #payeesTable let-payees>
  <ion-list
    class="payees-table"
    [class.with-checkbox-col]="isLinkedPayeeSelection()"
    lines="none"
    >
    <ion-item class="table-header" lines="none">
      @if (isLinkedPayeeSelection()) {
        <ion-label class="col checkbox" />
      }
      <ion-label class="col nome sortable" (click)="onSortColumn('companyName')">
        <span>Nome</span>
        <ion-icon [name]="getSortIconFor('companyName')" class="sort-icon" />
      </ion-label>
      <ion-label class="col status">Status</ion-label>
      <ion-label class="col total-balance sortable" (click)="onSortColumn('totalBalance')">
        <span>Total disponível</span>
        <ion-icon [name]="getSortIconFor('totalBalance')" class="sort-icon" />
      </ion-label>
      <ion-label class="col date sortable" (click)="onSortColumn('invitedAt')">
        <span>Convidado em</span>
        <ion-icon [name]="getSortIconFor('invitedAt')" class="sort-icon" />
      </ion-label>
      <ion-label class="col share sortable" (click)="onSortColumn('share')">
        <span>Repasse Autoral</span>
        <ion-icon [name]="getSortIconFor('share')" class="sort-icon" />
      </ion-label>
      <ion-label class="col composers">Compositores</ion-label>
      @if (!isLinkedPayeeSelection()) {
        <ion-label class="col select">Selecionar</ion-label>
      }
    </ion-item>

    @for (payee of payees; track payee.objectID; let i = $index) {
      <ion-item
        lines="none"
        class="table-row"
        [detail]="false"
        [class.child-payee-row]="payee.__isChildPayeeDisplay"
        [class.highlighted]="payee.__highlight || payee.__selected || payee.objectID === signedInPayeeId || payee.id === signedInPayeeId"
        button
        (click)="select(payee.objectID)"
        >
        @if (isLinkedPayeeSelection()) {
          <ion-label class="col checkbox" (click)="$event.stopPropagation()">
            @if (!payee.__isChildPayeeDisplay) {
              <ion-checkbox
                [checked]="selectedPayees().includes(payee.objectID)"
                (ionChange)="select(payee.objectID)"
                class="selection-checkbox" />
            }
          </ion-label>
        }
        <ion-label class="col nome">
          <div class="name-cell">
            @if (payee.__isChildPayeeDisplay) {
              <ion-icon name="return-down-forward-outline" class="child-indicator-icon" />
            }
            <div class="name-content">
              <span class="company-name" [innerHTML]="payee._highlightResult?.companyName?.value || payee.companyName"></span>
              @if (payee.__isChildPayeeDisplay && payee.__parentCompanyName) {
                <span class="linked-to">vinculado a {{ payee.__parentCompanyName }}</span>
              }
              @if (!payee.__isChildPayeeDisplay && payee.internalProperties?.linkedPayees?.length > 0) {
                <span class="linked-to">
                  Principal, com {{ payee.internalProperties.linkedPayees.length }} vinculado(s)
                  @if (isLoadingChildren(payee)) {
                    <ion-spinner name="dots" class="child-loading-spinner" />
                  }
                </span>
              }
            </div>
          </div>
        </ion-label>
        <ion-label class="col status">
          @if (getStatusInfo(payee); as info) {
            <ion-chip [color]="info.color" class="status-chip">
              <ion-icon [name]="info.icon" [color]="info.color" />
              <ion-label>{{ info.label }}</ion-label>
            </ion-chip>
          }
        </ion-label>
        <ion-label class="col total-balance">
          <span>{{ payee.internalProperties?.totalBalance || 0 | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</span>
        </ion-label>
        <ion-label class="col date">
          @if (toDate(payee.internalProperties?.invitedAt); as d) {
            <span>{{ d | date:'dd/MM/yyyy' }}</span>
          } @else {
            <span class="empty-cell">—</span>
          }
        </ion-label>
        <ion-label class="col share">
          <span>{{ payee.internalProperties?.share || 0 }}%</span>
        </ion-label>
        <ion-label class="col composers" (click)="$event.stopPropagation()">
          @if (payee.internalProperties?.composers?.length > 0) {
            <button
              type="button"
              class="composers-button"
              (click)="openComposersPopover($event, payee)"
              >
              <ion-icon name="people-outline" />
              <span>{{ payee.internalProperties.composers.length }}</span>
            </button>
          } @else {
            <span class="empty-cell">0</span>
          }
        </ion-label>
        @if (!isLinkedPayeeSelection()) {
          <ion-label class="col select" (click)="$event.stopPropagation()">
            <button
              type="button"
              class="select-payee-button"
              (click)="selectAsCurrentPayee(payee)"
              title="Selecionar beneficiário">
              <ion-icon name="person-circle-outline" />
            </button>
          </ion-label>
        }
      </ion-item>
    }
  </ion-list>
</ng-template>

<!-- Composers popover -->
<ion-popover
  [isOpen]="popoverOpen"
  [event]="popoverEvent"
  [showBackdrop]="false"
  [dismissOnSelect]="false"
  [arrow]="true"
  side="bottom"
  alignment="center"
  class="composers-popover"
  (didDismiss)="onComposersPopoverDismiss()"
  >
  <ng-template>
    <div class="composers-popover-content">
      <div class="composers-popover-header">
        <ion-icon name="people-outline" />
        <span>Compositores ({{ popoverComposers.length }})</span>
      </div>
      <ion-list lines="inset">
        @for (composer of popoverComposers; track composer.id) {
          <ion-item button (click)="onComposerClick(composer)" detail="false">
            <ion-label>
              <span>{{ composer.companyName }}</span>
            </ion-label>
          </ion-item>
        }
      </ion-list>
    </div>
  </ng-template>
</ion-popover>
